export default __webpack_public_path__ + "static/media/Wham - Last Christmas.d8f14356.mp3";